import { css } from '@emotion/react';
import { EmojiClickData } from 'emoji-picker-react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { EmojiButton } from '@frontend/design-system';

export interface EmojiActionProps {
  onSelect: (emoji: EmojiClickData) => void;
}

export const EmojiAction = ({ onSelect }: EmojiActionProps) => {
  const { t } = useTranslation('team-chat');
  return (
    <EmojiButton
      css={styles}
      onSelect={onSelect}
      trackingId='team-chat-2.0-add-emoji-button'
      label={t('Add Reaction')}
    />
  );
};

const styles = css`
  height: ${theme.spacing(4)};
  min-width: ${theme.spacing(4)};
  width: ${theme.spacing(4)};
`;
